import {Component, Inject, OnInit} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { BusquedaAvanzadaService } from '../../services/busqueda-avanzada.service';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-buscador-general',
    templateUrl: './buscador-general.component.html',
    styleUrls: ['./buscador-general.component.scss']
})
export class BuscadorGeneralComponent implements OnInit {
    search = new FormControl();
    pathRedirect = './busqueda-avanzada';
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private _router: Router,
        private _busquedaAvazandaService: BusquedaAvanzadaService
    ) { }

    ngOnInit(): void {
        this.document.location.href.split('/').forEach(url => {
            switch (url) {
                case 'usuario-final': this._busquedaAvazandaService.origenSearch$.next('usuario-final'); break;
                case 'administrador': this._busquedaAvazandaService.origenSearch$.next('administrador'); break;
                case 'digitalizacion': this._busquedaAvazandaService.origenSearch$.next('digitalizacion'); break;
                case 'despacho': this._busquedaAvazandaService.origenSearch$.next('despacho'); break;
                case 'fedatario': this._busquedaAvazandaService.origenSearch$.next('fedatario'); break;
                case 'mesa-de-partes': this._busquedaAvazandaService.origenSearch$.next('mesa-de-partes'); break;
                case 'control-calidad': this._busquedaAvazandaService.origenSearch$.next('control-calidad'); break;
            }
        })
        this.search.valueChanges.pipe(
            debounceTime(500)
        ).subscribe(value => {
            console.log(value);
            setTimeout(() => {
                this._busquedaAvazandaService.generalSearch$.next(value);
            }, 1);
            this._router.navigate([this.pathRedirect]);
        });
    }

    submitSearch() {

        this._router.navigate([this.pathRedirect]);
    }
}
